
/**
 * youtube播放器
 */
class YouTubeSdk {
  constructor() {
  }

  async init() {
    await this.loadScript();
  }

  loadScript() {
    return new Promise(resolve => {
      let id = 'youtube-sdk';
      let scriptEl = document.getElementById(id);
      if (scriptEl) {
        resolve();
      } else {
        let script = document.createElement('script');
        let head = document.querySelector('head');
        script.src = '//www.youtube.com/iframe_api';
        script.id = id;
        script.onload = () => {
          window.onYouTubePlayerAPIReady = function () {
            resolve();
          }
        }
        head.appendChild(script);
      }
    });
  }

  initPlayer(
    {
      playerId = 'youtube-player',
      option = {
        width: '100%',
        height: '100%',
        events: {}
      }
    }) {
    if (typeof YT === 'undefined') {
      return null;
    }
    const player = new YT.Player(playerId, option);
    return player;
  }
};

export default YouTubeSdk;


// WEBPACK FOOTER //
// ./src/lib/you-tube/youTube.js